<template>
  <ul
    class="nav nav-pills nav-fill form-navigation"
    :class="{ simple: simple }"
  >
    <template v-for="(tab, index) in tabs">
      <li
        role="presentation"
        class="nav-item"
        v-bind:key="index"
        v-if="shouldDisplay(tab)"
      >
        <a
          href="#"
          class="nav-link"
          v-on:click.prevent="chooseTab(tab)"
          v-text="tab.label"
          :class="{ active: active == tab.name, disabled: tab.disabled }"
        ></a>
      </li>
    </template>
  </ul>
</template>
<script>
export default {
  props: {
    simple: {
      type: Boolean,
      default: false
    },
    tabs: {
      type: Array,
      required: true
    },
    enableLogging: {
      type: Boolean,
      required: false,
      default: false
    },
    incident: {
      type: String,
      required: false
    },
    module: {
      type: String,
      required: false
    },
    parentTabs: {
      type: Array,
      required: false
    },
    active: {
      type: [String, Number],
      required: false
    }
  },

  methods: {
    chooseTab(tab) {
      if (!tab.disabled) {
        this.$emit('selected', tab.name);

        // If logging is enabled then log the tab the user loaded
        if (this.enableLogging) {
          const tabs = [...(this.parentTabs || []), tab.label];

          window.Ajax.post(`/incidents/${this.incident}/log`, {
            module: this.module,
            tab: tabs.join(' - ')
          });
        }
      }
    },

    shouldDisplay(tab) {
      if (tab['when']) {
        return tab.when();
      }

      return true;
    }
  }
};
</script>
